import tw from 'twin.macro'

export const LargeHeader = tw`text-[36px] line-height[39.6px] lg:(text-[56px] line-height[61.6px])`
export const Header = tw`text-[22px] line-height[27px] lg:(text-[36px] line-height[43.2px])`
export const SubHeader = tw`text-[22px] line-height[26.4px] lg:(text-[28px] line-height[33.6px])`
export const SmallHeader = tw`text-[22px] line-height[26.4px] lg:(text-[22px] line-height[26.4px])`
export const Body = tw`text-[16px] line-height[19.2px]`
export const SmallBody = tw`text-[12px] line-height[14.4px]`

export const Grid = tw.div`h-full grid grid-cols-4 gap-x-5 mx-[30px] lg:(max-w-screen-lg mx-auto grid-cols-12 gap-x-6) xl:(max-w-screen-xl max-width[1200px])`
